<c-container fluid>
  <h2 class="mb-4">{{ 'wpcp.admin.pool_title' | translate }}</h2>

  <c-alert *ngIf="message() as m" [color]="m.type" [dismissible]="false">{{ m.text }}</c-alert>

  <c-card class="mb-4">
    <c-card-body>
      <div class="d-flex flex-wrap align-items-center gap-3">
        <div *ngIf="config() as c" class="small text-medium-emphasis">
          Community: {{ (c.community_ratio * 100) | number:'1.0-1' }}% · Legacy: {{ (c.legacy_ratio * 100) | number:'1.0-1' }}% · Reserve: {{ c.reserve }}
        </div>
        <input class="form-control" style="max-width:200px" [(ngModel)]="weekKey" placeholder="Week (optional, e.g. 2026-W31)" />
        <button cButton variant="outline" color="secondary" (click)="runDry()">{{ 'wpcp.admin.run_dry' | translate }}</button>
        <button cButton color="primary" (click)="runReal()">{{ 'wpcp.admin.run' | translate }}</button>
      </div>

      <!-- The waterfall, in the order the money actually moves: fixed bonuses
           first, points last. Reading it top to bottom explains any zero week. -->
      <div *ngIf="preview() as p" class="mt-4">
        <div class="fw-semibold mb-2">
          Preview {{ p.settlement_key }}
          <span class="text-medium-emphasis small">
            · {{ p.counts.eligible_memberships }} eligible memberships
          </span>
        </div>

        <c-row class="g-3">
          <c-col [md]="5">
            <table class="table table-sm mb-0">
              <tbody>
                <tr>
                  <td>Pool balance <span class="text-medium-emphasis small">(less {{ p.pot.reserve }} reserve)</span></td>
                  <td class="text-end fw-semibold">{{ p.pot.total | number:'1.2-2' }}</td>
                </tr>
                <tr>
                  <td class="ps-3">→ {{ ratioPct(p.split.community_ratio) | number:'1.0-1' }}% compensation side</td>
                  <td class="text-end">{{ p.split.compensation_side | number:'1.2-2' }}</td>
                </tr>
                <tr>
                  <td class="ps-3">→ {{ ratioPct(p.split.legacy_ratio) | number:'1.0-1' }}% Legacy Notes</td>
                  <td class="text-end">{{ p.split.legacy_side | number:'1.2-2' }}</td>
                </tr>

                <tr class="border-top">
                  <td>1 — Leadership <span class="text-medium-emphasis small">({{ p.counts.leadership_recipients }})</span></td>
                  <td class="text-end">− {{ p.fixed.leadership | number:'1.2-2' }}</td>
                </tr>
                <tr>
                  <td>2 — Pack Hero <span class="text-medium-emphasis small">({{ p.counts.pack_hero_recipients }})</span></td>
                  <td class="text-end">− {{ p.fixed.pack_hero | number:'1.2-2' }}</td>
                </tr>
                <tr *ngIf="usedLegacy(p.fixed)" class="table-warning">
                  <td>covered from the Legacy Notes side</td>
                  <td class="text-end">+ {{ p.fixed.legacy_transfer | number:'1.2-2' }}</td>
                </tr>
                <tr *ngIf="isCut(p.fixed)" class="table-danger">
                  <td>
                    every fixed bonus cut to {{ ratioPct(p.fixed.funding_ratio) | number:'1.1-4' }}%
                    <div class="small">the unpaid remainder expires — no debt, no carry-forward</div>
                  </td>
                  <td class="text-end">×&nbsp;{{ p.fixed.funding_ratio }}</td>
                </tr>

                <tr class="border-top">
                  <td class="fw-semibold">3 — left for the points</td>
                  <td class="text-end fw-semibold">{{ p.points.remaining_pool | number:'1.2-2' }}</td>
                </tr>
                <tr>
                  <td class="ps-3">{{ p.points.total_points | number:'1.0-2' }} points in the system</td>
                  <td class="text-end">
                    {{ p.points.point_value | number:'1.2-6' }} <span class="text-medium-emphasis small">per point</span>
                  </td>
                </tr>
                <tr>
                  <td class="ps-3">Legacy Notes pot after any transfer</td>
                  <td class="text-end">{{ p.legacy_notes.pot | number:'1.2-2' }}</td>
                </tr>
              </tbody>
            </table>

            <c-alert *ngIf="p.points.remaining_pool <= 0" color="warning" class="mt-3 mb-0 py-2 small">
              No point payout this week — the qualified fixed bonuses consumed the
              whole compensation side. This is the intended behaviour, not an error.
            </c-alert>
          </c-col>

          <c-col [md]="7">
            <div class="fw-semibold small">Leadership ({{ p.leadership_lines.length }})</div>
            <div style="max-height:150px; overflow:auto">
              <table class="table table-sm table-striped mb-2">
                <thead><tr><th>User</th><th>Rank</th><th class="text-end">Org</th><th class="text-end">Weekly</th><th class="text-end">Paid</th></tr></thead>
                <tbody>
                  <tr *ngFor="let l of p.leadership_lines">
                    <td>{{ l.user_id }}</td><td>{{ l.rank }}</td>
                    <td class="text-end">{{ l.counted }}</td>
                    <td class="text-end">{{ l.weekly | number:'1.2-2' }}</td>
                    <td class="text-end fw-semibold">{{ l.amount | number:'1.2-2' }}</td>
                  </tr>
                  <tr *ngIf="!p.leadership_lines.length"><td colspan="5" class="text-medium-emphasis small">nobody qualified</td></tr>
                </tbody>
              </table>
            </div>

            <div class="fw-semibold small">Pack Hero ({{ p.pack_hero_lines.length }})</div>
            <div style="max-height:120px; overflow:auto">
              <table class="table table-sm table-striped mb-2">
                <thead><tr><th>User</th><th>Level</th><th class="text-end">Platin</th><th class="text-end">Weekly</th><th class="text-end">Paid</th></tr></thead>
                <tbody>
                  <tr *ngFor="let l of p.pack_hero_lines">
                    <td>{{ l.user_id }}</td><td>{{ l.level }}</td>
                    <td class="text-end">{{ l.platin_count }}</td>
                    <td class="text-end">{{ l.weekly | number:'1.2-2' }}</td>
                    <td class="text-end fw-semibold">{{ l.amount | number:'1.2-2' }}</td>
                  </tr>
                  <tr *ngIf="!p.pack_hero_lines.length"><td colspan="5" class="text-medium-emphasis small">nobody qualified</td></tr>
                </tbody>
              </table>
            </div>

            <div class="fw-semibold small">
              Community Points ({{ p.counts.point_recipients }}<span *ngIf="p.counts.point_recipients > p.point_lines.length">, top {{ p.point_lines.length }}</span>)
            </div>
            <div style="max-height:180px; overflow:auto">
              <table class="table table-sm table-striped mb-0">
                <thead><tr><th>User</th><th class="text-end">Points</th><th class="text-end">Credit</th></tr></thead>
                <tbody>
                  <tr *ngFor="let l of p.point_lines">
                    <td>{{ l.user_id }}</td>
                    <td class="text-end">{{ l.points }}</td>
                    <td class="text-end fw-semibold">{{ l.amount | number:'1.2-2' }}</td>
                  </tr>
                  <tr *ngIf="!p.point_lines.length"><td colspan="3" class="text-medium-emphasis small">no point payout</td></tr>
                </tbody>
              </table>
            </div>

            <!-- The Legacy Notes leg is part of the same weekly run and draws from
                 the same pool, so it belongs in the same preview — otherwise the
                 30 % side is a number nobody can check. -->
            <div class="fw-semibold small mt-2">
              Legacy Notes ({{ p.legacy_notes.recipients }}<span *ngIf="p.legacy_notes.recipients > p.legacy_notes.lines.length">, top {{ p.legacy_notes.lines.length }}</span>)
            </div>
            <div style="max-height:180px; overflow:auto">
              <table class="table table-sm table-striped mb-0">
                <thead><tr><th>User</th><th>Pool</th><th class="text-end">Shares</th><th class="text-end">Credit</th></tr></thead>
                <tbody>
                  <tr *ngFor="let l of p.legacy_notes.lines">
                    <td>{{ l.user_id }} <span class="small text-medium-emphasis">{{ l.email }}</span></td>
                    <td>{{ l.pool_id }}</td>
                    <td class="text-end">{{ l.weighted_shares }}</td>
                    <td class="text-end fw-semibold">{{ l.amount | number:'1.2-2' }}</td>
                  </tr>
                  <tr *ngIf="!p.legacy_notes.lines.length"><td colspan="4" class="text-medium-emphasis small">no Legacy Notes payout</td></tr>
                </tbody>
              </table>
            </div>
          </c-col>
        </c-row>
      </div>
    </c-card-body>
  </c-card>

  <c-card>
    <c-card-header><strong>{{ 'wpcp.history' | translate }}</strong></c-card-header>
    <c-card-body>
      <div *ngIf="loading()" class="text-center py-3"><c-spinner /></div>
      <table class="table table-hover table-sm" *ngIf="!loading()">
        <thead>
          <tr>
            <th>{{ 'wpcp.admin.settlement_week' | translate }}</th>
            <th>{{ 'wpcp.admin.status' | translate }}</th>
            <th class="text-end">Fixed</th>
            <th class="text-end">Points</th>
            <th class="text-end">Point value</th>
            <th>{{ 'wpcp.admin.recipients' | translate }}</th>
            <th>{{ 'wpcp.admin.booked' | translate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let s of settlements()" style="cursor:pointer" (click)="openDetail(s)">
            <td>{{ s.settlement_key }}</td>
            <td>
              <c-badge [color]="statusColor(s.status)">{{ s.status }}</c-badge>
              <!-- A cut week paid everyone less than they qualified for; that has to
                   be visible in the list, not only inside the detail view. -->
              <c-badge color="danger" class="ms-1" *ngIf="isCut(s)"
                       [title]="'fixed bonuses cut to ' + (ratioPct(s.funding_ratio) | number:'1.1-4') + '%'">cut</c-badge>
              <c-badge color="warning" class="ms-1" *ngIf="usedLegacy(s) && !isCut(s)"
                       title="shortfall covered from the Legacy Notes side">legacy</c-badge>
            </td>
            <td class="text-end">{{ s.fixed_bonus_total | number:'1.2-2' }}</td>
            <td class="text-end">{{ s.remaining_point_pool | number:'1.2-2' }}</td>
            <td class="text-end">{{ s.point_value | number:'1.2-6' }}</td>
            <td>{{ s.recipient_count }}</td>
            <td class="small">
              <span *ngFor="let cur of currencyKeys(s.total_credited)">{{ s.total_credited[cur] }} {{ cur }} </span>
            </td>
            <td>{{ s.completed_at | date:'short' }}</td>
          </tr>
        </tbody>
      </table>
    </c-card-body>
  </c-card>

  <c-modal [visible]="detailVisible()" (visibleChange)="detailVisible.set($event)" size="xl" backdrop="static">
    <c-modal-header>
      <h5 cModalTitle>{{ detail()?.settlement?.settlement_key }}</h5>
      <button cButtonClose (click)="detailVisible.set(false)"></button>
    </c-modal-header>
    <c-modal-body>
      <table class="table table-sm mb-3" *ngIf="detail()?.settlement as w">
        <tbody>
          <tr><td>Compensation side</td><td class="text-end">{{ w.remaining_point_pool + w.fixed_bonus_total | number:'1.2-2' }}</td>
              <td>Leadership</td><td class="text-end">{{ w.leadership_total | number:'1.2-2' }}</td></tr>
          <tr><td>Legacy transfer</td><td class="text-end">{{ w.legacy_transfer | number:'1.2-2' }}</td>
              <td>Pack Hero</td><td class="text-end">{{ w.pack_hero_total | number:'1.2-2' }}</td></tr>
          <tr><td>Left for points</td><td class="text-end fw-semibold">{{ w.remaining_point_pool | number:'1.2-2' }}</td>
              <td>Funding ratio</td><td class="text-end" [class.text-danger]="isCut(w)">{{ ratioPct(w.funding_ratio) | number:'1.1-4' }}%</td></tr>
          <tr><td>Points in system</td><td class="text-end">{{ w.total_system_points | number:'1.0-2' }}</td>
              <td>Point value</td><td class="text-end">{{ w.point_value | number:'1.2-6' }}</td></tr>
          <tr><td>Direct compensation</td>
              <td class="text-end">{{ w.direct_compensation_total | number:'1.2-2' }}</td>
              <td colspan="2" class="small text-medium-emphasis">informational — booked by the commission process, not paid here</td></tr>
        </tbody>
      </table>
      <!-- Totals per component first: with several hundred Legacy Notes lines the
           flat list alone makes it impossible to see what each leg actually paid. -->
      <div class="d-flex flex-wrap gap-3 mb-2" *ngIf="detail() as d">
        <div *ngFor="let k of kindsIn(d.payouts)" class="small">
          <span class="fw-semibold">{{ k }}</span>
          <span class="text-medium-emphasis"> · {{ countOfKind(d.payouts, k) }} lines · </span>
          {{ sumOfKind(d.payouts, k) | number:'1.2-2' }}
        </div>
      </div>
      <div class="mb-2" *ngIf="detail() as d">
        <select class="form-select form-select-sm" style="max-width:260px" [(ngModel)]="kindFilter">
          <option value="">all components</option>
          <option *ngFor="let k of kindsIn(d.payouts)" [value]="k">{{ k }}</option>
        </select>
      </div>
      <table class="table table-sm" *ngIf="detail() as d">
        <thead><tr><th>User</th><th>Kind</th><th>Cur</th><th>Points/Weight</th><th>Unit</th><th>Credit</th><th>Status</th></tr></thead>
        <tbody>
          <tr *ngFor="let p of filteredPayouts(d.payouts)">
            <td>{{ p.user_id }}</td>
            <td>{{ p.kind }}</td>
            <td>{{ p.currency }}</td>
            <td>{{ p.points_or_weight }}</td>
            <td>{{ p.unit_value }}</td>
            <td>{{ p.final_credit }}</td>
            <td><c-badge [color]="p.status === 'credited' ? 'success' : (p.status === 'failed' ? 'danger' : 'secondary')">{{ p.status }}</c-badge></td>
          </tr>
        </tbody>
      </table>
    </c-modal-body>
  </c-modal>
</c-container>
